import { HousePricesModuleGetServerSideProps } from 'components/modules/housePrices/serverSide';
import { pageResolver } from 'lib/utils/helpers/pageResolver';
import dynamic from 'next/dynamic';

const HousePricesPageRoot = dynamic(
  async () => (await import('components/modules/housePrices')).HousePricesPageRoot
);

const { PageModule, getServerSideProps } = pageResolver(HousePricesPageRoot, HousePricesModuleGetServerSideProps);

export default PageModule;
export {
  getServerSideProps
}

